<template>
  <section class="our-course-section section">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="premium-head">
            <span class="ph-badge wow fadeInUp" data-wow-delay=".1s">কোর্স সমূহ</span>
            <h2 class="wow fadeInUp" data-wow-delay=".2s">আমাদের কোর্স সমূহ</h2>
            <p class="wow fadeInUp" data-wow-delay=".3s">
              বিসিএস, ব্যাংক, প্রাইমারি, শিক্ষক নিবন্ধন, সহকারী জজ সহ সকল
              চাকরির প্রস্তুতি কোর্স
            </p>
            <div class="ph-line wow fadeInUp" data-wow-delay=".4s"></div>
          </div>
        </div>
      </div>
      <div class="row course-list">
        <div v-for="(course, index) in shuffleCourseList.slice(0,6)" :key="index" class="our-course-box wow fadeInUp" data-wow-delay=".2s">
          <div class="top-section">
            <div class="top-section-content">
              <img
                  :src="course.image"
                  height="190"
                  style="border-radius: 16px; width: 100%"
              />
            </div>
          </div>
          <div class="bottom-section">
            <h3>{{ course.title }}</h3>
            <p>{{ course.short_description }}...</p>
            <a @click="goToCourseDetails(course)" class="course-link">
              <span>বিস্তারিত পড়ুন</span>
              <span class="course-link__icon">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M13.2673 4.20926C12.9674 3.92357 12.4926 3.93511 12.2069 4.23504C11.9213 4.53497 11.9328 5.0097 12.2327 5.29539L18.4841 11.25H3.75C3.33579 11.25 3 11.5858 3 12C3 12.4142 3.33579 12.75 3.75 12.75H18.4842L12.2327 18.7047C11.9328 18.9904 11.9213 19.4651 12.2069 19.7651C12.4926 20.065 12.9674 20.0765 13.2673 19.7908L20.6862 12.7241C20.8551 12.5632 20.9551 12.358 20.9861 12.1446C20.9952 12.0978 21 12.0495 21 12C21 11.9504 20.9952 11.902 20.986 11.8551C20.955 11.6419 20.855 11.4368 20.6862 11.276L13.2673 4.20926Z"
                      fill="currentColor"/>
                </svg>
              </span>
            </a>
          </div>
        </div>
      </div>

      <div v-if="courseList.length >= 6" class="row p-5">
        <div class="col-12 text-center">
          <a href="/course-list" class="btn-see-all">
            <span>সব কোর্স দেখুন</span>
            <svg class="btn-see-all__icon" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M13.2673 4.20926C12.9674 3.92357 12.4926 3.93511 12.2069 4.23504C11.9213 4.53497 11.9328 5.0097 12.2327 5.29539L18.4841 11.25H3.75C3.33579 11.25 3 11.5858 3 12C3 12.4142 3.33579 12.75 3.75 12.75H18.4842L12.2327 18.7047C11.9328 18.9904 11.9213 19.4651 12.2069 19.7651C12.4926 20.065 12.9674 20.0765 13.2673 19.7908L20.6862 12.7241C20.8551 12.5632 20.9551 12.358 20.9861 12.1446C20.9952 12.0978 21 12.0495 21 12C21 11.9504 20.9952 11.902 20.986 11.8551C20.955 11.6419 20.855 11.4368 20.6862 11.276L13.2673 4.20926Z"
                  fill="currentColor"/>
            </svg>
          </a>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import {defineComponent} from "vue";
import router from "@/router";
import {URLs} from "@/static";
import {courseList} from "@/config/utils";
export default defineComponent({
  components: {},
  setup() {
    const goToCourseDetails = (course) => {
      router.push({
        name: URLs.ROUTE_COURSE_DETAILS_NAME,
        params: {
          title: course.url_text
        }
      });
    };
    const shuffleCourseList = courseList.sort(() => Math.random() - 0.5);
    return {
      goToCourseDetails,
      courseList,
      shuffleCourseList
    };
  },
});
</script>
<style scoped>
.course-list {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 20px;
}

.our-course-section {
  background-color: #f4f7fb;
  position: relative;
}

.our-course-section .section-title {
  margin-bottom: 30px;
}

.our-course-section .our-course-box {
  text-align: left;
  width: 100%;
  height: 400px;
  background-color: #fff;
  border-radius: 16px;
  position: relative;
  margin-top: 30px;
  border: 1px solid #eee;
  -webkit-transition: all 0.5s cubic-bezier(0.68, -0.55, 0.27, 1.55) 0s;
  transition: all 0.5s cubic-bezier(0.68, -0.55, 0.27, 1.55) 0s;
}

.our-course-section .our-course-box:hover {
  -webkit-box-shadow: 0px 3px 5px #00000017;
  box-shadow: 0px 3px 5px #00000017;
  -webkit-transform: translateY(-5px);
  transform: translateY(-5px);
}

.our-course-section .our-course-box .top-section {
  height: 230px;
  padding: 20px;
}

.our-course-section .our-course-box .bottom-section {
  height: max-content;
  padding: 0 20px 20px 20px;
}

.our-course-section .our-course-box .top-section .top-section-content {
  height: 100%;
  width: 100%;
  background-color: #EAF4FF;
  border-radius: 16px;
}

.our-course-section .our-course-box h3 {
  font-family: Noto Sans;
  font-size: 20px;
  font-weight: 700;
  line-height: 30px;
  text-align: left;
}

.our-course-section .our-course-box p {
  font-family: Inter;
  font-size: 16px;
  font-weight: 500;
  line-height: 23px;
  letter-spacing: -0.5px;
  text-align: left;
}

/* ===== Premium "বিস্তারিত পড়ুন" link ===== */
.course-link {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  cursor: pointer;
  font-family: "Noto Sans", sans-serif;
  font-weight: 700;
  font-size: 15px;
  color: #0095FF;
  text-decoration: none;
  transition: color 0.25s ease;
}

.course-link__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: rgba(0, 149, 255, 0.1);
  color: #0095FF;
  transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1), background 0.25s ease, color 0.25s ease;
}

.course-link:hover {
  color: #0077cc;
}

.course-link:hover .course-link__icon {
  transform: translateX(4px);
  background: #0095FF;
  color: #fff;
}

/* ===== Premium "সব কোর্স দেখুন" primary CTA ===== */
.btn-see-all {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-family: "Noto Sans", sans-serif;
  font-weight: 700;
  font-size: 16px;
  color: #fff;
  text-decoration: none;
  padding: 14px 34px;
  border-radius: 50px;
  background: linear-gradient(135deg, #38B6FF 0%, #0095FF 100%);
  box-shadow: 0 10px 24px rgba(0, 149, 255, 0.32), inset 0 1px 0 rgba(255, 255, 255, 0.35);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.btn-see-all__icon {
  transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.btn-see-all:hover {
  color: #fff;
  transform: translateY(-3px);
  box-shadow: 0 16px 32px rgba(0, 149, 255, 0.42), inset 0 1px 0 rgba(255, 255, 255, 0.35);
}

.btn-see-all:hover .btn-see-all__icon {
  transform: translateX(5px);
}

@media (max-width: 768px) {
  .course-list {
    grid-template-columns: 1fr;
  }
  .our-course-section .our-course-box {
    height: max-content;
  }
}
</style>
